<template>
  <div class="collapse-menu">
    <ul class="collapse-menu-list">
      <CollapseMenuItem
        v-for="(item, index) in menuData"
        :menu-data="item"
        :key="uuid()"
        :padding-left="paddingLeft"
        :icon-distance="iconDistance"
        :exact="exact"
        :onclick="onclick"
        :onopen="onopen"
        :onhide="onhide"
      ></CollapseMenuItem>
    </ul>
  </div>
</template>

<script>
import CollapseMenuItem from './CollapseMenuItem';
export default {
  name: 'CollapseMenu',
  provide() {
    return {
      // 将当前组件的引用传递给子孙组件使用
      collapseMenu: this
    };
  },
  props: {
    /*
     菜单节点数据
      [
        {
          text: '账户信息', // 菜单名字
          isRoute: true, // 是否是路由，默认为true。如果值为false，则此菜单不会使用<router-link>，而是使用普通的a标签
          url: '/safd', // 路由跳转路径，如果值为空，则会使用普通a标签代替，并且href为"javascript: void(0);"
          hasIcon: true, // 是否有图标
          iconName: "", // 图标名称，这里的图标使用的iconfont.cn中的icon，并且使用的是symbol模式
          open: false, // 节点是否展开,
          baseUrl: "", // 如果带了baseUrl则使用baseUrl进行比较
          exact: false, // 是否启用路由全匹配模式，这个与vue router的exact是一样的
          // 子菜单
          children: [
            { text: '手机验证', url: '/fasfd' },
            { text: '谷歌验证码', url: '/fasfd' },
          ],
        }
      ]
      */
    menuData: {
      type: Array,
      default() {
        return [];
      }
    },
    // 是否自动打开与路由匹配的菜单
    autoOpen: {
      type: Boolean,
      default: true
    },
    // 当前菜单的padding-left
    paddingLeft: {
      type: Number,
      default: 15
    },
    // 左侧icon与文字之间的距离
    iconDistance: {
      type: Number,
      default: 15
    },
    // 路由全包含匹配
    exact: {
      type: Boolean,
      default: false
    },
    // 节点点击事件
    onclick: {
      type: Function,
      default: undefined
    },
    // 节点展开事件
    onopen: {
      type: Function,
      default: undefined
    },
    // 节点收缩事件事件
    onhide: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      // 子节点中有用到
      count: 0,
      totalNodes: 0
    };
  },
  methods: {
    uuid() {
      return (
        Math.random()
          .toString(32)
          .substr(2) +
        '_' +
        new Date().getTime() +
        '_' +
        Math.random()
          .toString(32)
          .substr(2)
      );
    },
    calculateTotalNodes(datas) {
      datas.forEach(item => {
        this.totalNodes++;
        if (item.children) {
          this.calculateTotalNodes(item.children);
        }
      });
    }
  },
  components: {
    CollapseMenuItem
  }
};
</script>

<style lang="stylus">
@import './collapse-menu.styl';
</style>
